export default {
    apiUrl: process.env.VUE_APP_API_URL || 'https://fv1.eu/api',
};
